export const GIT_SHA = process.env.REACT_APP_GIT_SHA;
export const BUILD_DATE = process.env.REACT_APP_BUILD_DATE;
